// extracted by mini-css-extract-plugin
module.exports = {"item":"NavItem_item__iAsYx","active":"NavItem_active__P263O"};